import { __decorate } from "tslib";
import { FrontendFeaturePlugin, provideRootRoutes } from '@core/frontend-shared';
import { ClassName } from '@core/shared/class-name';
import * as i0 from "@angular/core";
let PflegethekeQuestionsFrontendFeature = /*#__PURE__*/(() => {
  let PflegethekeQuestionsFrontendFeature = class PflegethekeQuestionsFrontendFeature extends FrontendFeaturePlugin {
    getFeatureContext() {
      return {"package":"@pflegetheke/questions/frontend","featureId":"pflegetheke-questions"};
    }
    getFeatureFunctionality(functionality) {}
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵPflegethekeQuestionsFrontendFeature_BaseFactory;
        return function PflegethekeQuestionsFrontendFeature_Factory(__ngFactoryType__) {
          return (ɵPflegethekeQuestionsFrontendFeature_BaseFactory || (ɵPflegethekeQuestionsFrontendFeature_BaseFactory = i0.ɵɵgetInheritedFactory(PflegethekeQuestionsFrontendFeature)))(__ngFactoryType__ || PflegethekeQuestionsFrontendFeature);
        };
      })();
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: PflegethekeQuestionsFrontendFeature
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        providers: [provideRootRoutes([{
          path: 'questions',
          loadChildren: () => import('./questions-frontend.module').then(m => m.QuestionsFrontendModule)
        }])]
      });
    }
  };
  PflegethekeQuestionsFrontendFeature = __decorate([ClassName("PflegethekeQuestionsFrontendFeature")], PflegethekeQuestionsFrontendFeature);
  return PflegethekeQuestionsFrontendFeature;
})();
export { PflegethekeQuestionsFrontendFeature };